import { createFileRoute, lazyRouteComponent } from '@tanstack/react-router';

export const Route = createFileRoute('/_authenticated/settings_/territories/')({
  component: lazyRouteComponent(() => import('&/features/settings/territories/pages/territories-page')),
  staticData: { titleKey: 'territories' },
});
